import React from "react";
import * as S from "./styled";
import PT from "prop-types";
import InteriorPhotos from "./InteriorPhotos";
import Schedule from "./Schedule";
import Masters from "./Masters";
import Map from "./Map";

const SaloonAside = (props) => {
  return (
    <S.Wrap>
      <S.ListBlock>
        <Masters t={props.t} masters={props.masters} isOwner={props.isOwner} />
        <S.ListDelim />
        <InteriorPhotos
          defaultAltText={props.interiorPhotoDefaultAltText}
          t={props.t}
          isOwner={props.isOwner}
          photos={props.interior}
        />
      </S.ListBlock>
      <Map
        locale={props.locale}
        t={props.t}
        saloonId={props.saloonId}
        isOwner={props.isOwner}
        coords={props.coords}
        isPremium={props.isPremium}
      />
      <Schedule
        t={props.t}
        isOwner={props.isOwner}
        weekSchedule={props.weekSchedule}
      />
    </S.Wrap>
  );
};
SaloonAside.propTypes = {
  saloonId: PT.string,
  interior: PT.array,
  isOwner: PT.bool,
  weekSchedule: PT.array,
  coords: PT.array,
  isPremium: PT.bool,
  locale: PT.string,
  masters: PT.array,
  interiorPhotoDefaultAltText: PT.string,

  t: PT.func.isRequired,
};
export default SaloonAside;
